import './src/styles/global.css'
import { eventService, initializeEventRuntime } from './src/services/events'

export const onClientEntry = () => {
  initializeEventRuntime()
}

export const onRouteUpdate = ({ location }) => {
  initializeEventRuntime()

  eventService.trackPageView({
    path: location.pathname,
    search: location.search,
    title: typeof document !== 'undefined' ? document.title : '',
  })
}
